import { defineMessages } from "react-intl";

const commonResources = defineMessages({
  mutabakat: {
    id: "masterdata.common.mutabakat",
    defaultMessage: "MUTABAKAT",
  },
  emutabakat: {
    id: "masterdata.common.emutabakat",
    defaultMessage: "E-MUTABAKAT",
  },
  emutabakatFooter: {
    id: "masterdata.common.emutabakatFooter",
    defaultMessage: "E-Mutabakat ©2020 Arkas Holding A.Ş.",
  },
  ok: {
    id: "masterdata.common.ok",
    defaultMessage: "Tamam",
  },
  kaydet: {
    id: "masterdata.common.kaydet",
    defaultMessage: "Kaydet",
  },
  listeyeGeriDon: {
    id: "masterdata.common.listeyeGeriDon",
    defaultMessage: "Listeye Geri Dön",
  },
  aktif: {
    id: "masterdata.common.aktif",
    defaultMessage: "Aktif",
  },
  pasif: {
    id: "masterdata.common.pasif",
    defaultMessage: "Pasif",
  },
  tumu: {
    id: "masterdata.common.tumu",
    defaultMessage: "Tümü",
  },
  evet: {
    id: "masterdata.common.evet",
    defaultMessage: "Evet",
  },
  hayir: {
    id: "masterdata.common.hayir",
    defaultMessage: "Hayır",
  },
  yeni: {
    id: "masterdata.common.yeni",
    defaultMessage: "Yeni",
  },
  temizle: {
    id: "masterdata.common.temizle",
    defaultMessage: "Temizle",
  },
  ara: {
    id: "masterdata.common.ara",
    defaultMessage: "Ara",
  },
  logoUpdateIfadesi: {
    id: "masterdata.common.logoUpdateIfadesi",
    defaultMessage: "Lütfen ekleyeceğiniz logoyu sisteme upload ediniz.",
  },
  kullaniciListesi: {
    id: "masterdata.common.kullaniciListesi",
    defaultMessage: "Kullanıcı Listesi",
  },
  adGiriniz: {
    id: "masterdata.common.adGiriniz",
    defaultMessage: "Ad Giriniz",
  },
  maxKarakter: {
    id: "masterdata.common.maxKarakter",
    defaultMessage: "Max. {length} karakter",
  },
  sirketSeciniz: {
    id: "masterdata.common.sirketSeciniz",
    defaultMessage: "Şirket Seçiniz",
  },
  soyadGiriniz: {
    id: "masterdata.common.soyadGiriniz",
    defaultMessage: "Soyad Giriniz",
  },
  emailGiriniz: {
    id: "masterdata.common.emailGiriniz",
    defaultMessage: "E-Mail Giriniz",
  },
  arkasKln: {
    id: "masterdata.common.arkasKln",
    defaultMessage: "Arkas Kln",
  },
  statu: {
    id: "masterdata.common.statu",
    defaultMessage: "Statü",
  },
  ad: {
    id: "masterdata.common.ad",
    defaultMessage: "Ad",
  },
  soyad: {
    id: "masterdata.common.soyad",
    defaultMessage: "Soyad",
  },
  sirket: {
    id: "masterdata.common.sirket",
    defaultMessage: "Şirket",
  },
  sirketYetki: {
    id: "masterdata.common.sirketYetki",
    defaultMessage: "Şirket Yetki",
  },
  emailZorunludur: {
    id: "masterdata.common.emailZorunludur",
    defaultMessage: "E-mail zorunludur",
  },
  arkasKullanicisiEkle: {
    id: "masterdata.common.arkasKullanicisiEkle",
    defaultMessage: "Arkas Kullanıcısı Ekle",
  },
  basarili: {
    id: "masterdata.common.basarili",
    defaultMessage: "Başarılı",
  },
  yeniKayitBasarili: {
    id: "masterdata.common.yeniKayitBasarili",
    defaultMessage: "Yeni kayıt başarıyla yaratıldı.",
  },
  kayitGuncellemeBasarili: {
    id: "masterdata.common.kayitGuncellemeBasarili",
    defaultMessage: "Kayıt başarıyla güncellendi.",
  },
  dosyaYuklemeBasarili: {
    id: "masterdata.common.dosyaYuklemeBasarili",
    defaultMessage: "Dosya başarı ile yüklendi.",
  },
  hata: {
    id: "masterdata.common.hata",
    defaultMessage: "Hata",
  },
  onayGonderimHata: {
    id: "masterdata.common.onayGonderimHata",
    defaultMessage: "Farklı statude mutabakatlar birlikte onaya gönderilemez.",
  },
  onayGonderimOnayHata: {
    id: "masterdata.common.onayGonderimOnayHata",
    defaultMessage:
      "Müşteri onayında olan ya da onaylanmış mutabakatlar tekrar onaya gönderilemez",
  },
  guncellemedeHata: {
    id: "masterdata.common.guncellemedeHata",
    defaultMessage: "Güncellemede hata alındı.",
  },
  guncelle: {
    id: "masterdata.common.guncelle",
    defaultMessage: "Güncelle",
  },
  kayitBulunamadi: {
    id: "masterdata.common.kayitBulunamadi",
    defaultMessage: "Aranan kayıt sistemde bulunamadı.",
  },
  arkasKullanicisiMi: {
    id: "masterdata.common.arkasKullanicisiMi",
    defaultMessage: "Arkas Kullanıcısı Mı",
  },
  duzenle: {
    id: "masterdata.common.duzenle",
    defaultMessage: "Düzenle",
  },
  sil: {
    id: "masterdata.common.sil",
    defaultMessage: "Sil",
  },
  silmeyeEMinMisiniz: {
    id: "masterdata.common.silmeyeEMinMisiniz",
    defaultMessage: "Kaydı silmek istediğinize emin misiniz?",
  },
  silmeBasarili: {
    id: "masterdata.common.silmeBasarili",
    defaultMessage: "Kayıt başarıyla silindi.",
  },
  yonlendiriliyor: {
    id: "masterdata.common.yonlendiriliyor",
    defaultMessage: "Yönlendiriliyor...",
  },
  logoutConfirm: {
    id: "masterdata.common.logoutConfirm",
    defaultMessage: "Çıkış yapmak istediğinize emin misiniz?",
  },
  iptal: {
    id: "masterdata.common.iptal",
    defaultMessage: "İptal",
  },
  cikis: {
    id: "masterdata.common.cikis",
    defaultMessage: "Çıkış",
  },
  bildirimler: {
    id: "masterdata.common.bildirimler",
    defaultMessage: "Bildirimler",
  },
  unvan: {
    id: "masterdata.common.unvan",
    defaultMessage: "Ünvan",
  },
  musteriKodu: {
    id: "masterdata.common.musteriKodu",
    defaultMessage: "Müşteri Kodu",
  },
  vknTckn: {
    id: "masterdata.common.vknTckn",
    defaultMessage: "VKN/TCKN",
  },
  vknTcknWarning: {
    id: "masterdata.common.vknTcknWarning",
    defaultMessage:
      "VKN/TCKN bilgisi SAP'de gördüğünüz değerle aynı girilmelidir.",
  },
  grupKodu: {
    id: "masterdata.common.grupKodu",
    defaultMessage: "Grup Kodu",
  },
  cari: {
    id: "masterdata.common.cari",
    defaultMessage: "Cari",
  },
  adres: {
    id: "masterdata.common.adres",
    defaultMessage: "Adres",
  },
  iletisim: {
    id: "masterdata.common.iletisim",
    defaultMessage: "İletişim",
  },
  sapKodu: {
    id: "masterdata.common.sapKodu",
    defaultMessage: "SAP Kodu",
  },
  unvanGiriniz: {
    id: "masterdata.common.unvanGiriniz",
    defaultMessage: "Ünvan Giriniz",
  },
  vknTcknGiriniz: {
    id: "masterdata.common.vknTcknGiriniz",
    defaultMessage: "VKN / TCKN Giriniz",
  },
  sapKoduGiriniz: {
    id: "masterdata.common.sapKoduGiriniz",
    defaultMessage: "SAP Kodu Giriniz",
  },
  grupKoduGiriniz: {
    id: "masterdata.common.grupKoduGiriniz",
    defaultMessage: "Grup Kodu Giriniz",
  },
  detaylar: {
    id: "masterdata.common.detaylar",
    defaultMessage: "Detaylar",
  },
  musteriListesi: {
    id: "masterdata.common.musteriListesi",
    defaultMessage: "Müşteri/Satıcı Listesi",
  },
  vergiNoGiriniz: {
    id: "masterdata.common.vergiNoGiriniz",
    defaultMessage: "Vergi No Giriniz",
  },
  mersisNo: {
    id: "masterdata.common.mersisNo",
    defaultMessage: "Mersis No",
  },
  mersisNoGiriniz: {
    id: "masterdata.common.mersisNoGiriniz",
    defaultMessage: "Mersis No Giriniz",
  },
  ticaretSicilNo: {
    id: "masterdata.common.ticaretSicilNo",
    defaultMessage: "Ticaret Sicil No",
  },
  ticaretSicilNoGiriniz: {
    id: "masterdata.common.ticaretSicilNoGiriniz",
    defaultMessage: "Ticaret Sicil No Giriniz",
  },
  sanayiNo: {
    id: "masterdata.common.sanayiNo",
    defaultMessage: "Sanayi No",
  },
  sanayiNoGiriniz: {
    id: "masterdata.common.sanayiNoGiriniz",
    defaultMessage: "Sanayi No Giriniz",
  },
  vergiNo: {
    id: "masterdata.common.vergiNo",
    defaultMessage: "Vergi No",
  },
  telefon: {
    id: "masterdata.common.telefon",
    defaultMessage: "Telefon",
  },
  telefonGiriniz: {
    id: "masterdata.common.telefonGiriniz",
    defaultMessage: "Telefon Giriniz",
  },
  faks: {
    id: "masterdata.common.faks",
    defaultMessage: "Faks No",
  },
  faksGiriniz: {
    id: "masterdata.common.faksGiriniz",
    defaultMessage: "Faks Giriniz",
  },
  adresGiriniz: {
    id: "masterdata.common.adresGiriniz",
    defaultMessage: "Adres Giriniz",
  },
  sirketAdiZorunlu: {
    id: "masterdata.common.sirketAdiZorunlu",
    defaultMessage: "Şirket adı zorunludur",
  },
  ticaretSicilNoZorunlu: {
    id: "masterdata.common.ticaretSicilNoZorunlu",
    defaultMessage: "Ticaret sicil no zorunludur",
  },
  mersisNoZorunlu: {
    id: "masterdata.common.mersisNoZorunlu",
    defaultMessage: "Mersis no zorunludur",
  },
  sanayiNoZorunlu: {
    id: "masterdata.common.sanayiNoZorunlu",
    defaultMessage: "Sanayi no zorunludur",
  },
  sapKoduZorunlu: {
    id: "masterdata.common.sapKoduZorunlu",
    defaultMessage: "SAP kodu zorunludur",
  },
  telefonZorunlu: {
    id: "masterdata.common.telefonZorunlu",
    defaultMessage: "Telefon zorunludur",
  },
  faksZorunlu: {
    id: "masterdata.common.faksZorunlu",
    defaultMessage: "Faks zorunludur",
  },
  adresZorunlu: {
    id: "masterdata.common.adresZorunlu",
    defaultMessage: "Adres zorunludur",
  },
  vergiNoZorunlu: {
    id: "masterdata.common.vergiNoZorunlu",
    defaultMessage: "Vergi no zorunludur",
  },
  dosyaYuklemedeHata: {
    id: "masterdata.common.dosyaYuklemedeHata",
    defaultMessage: "Dosya yükleme sırasında bir hata oluştu.",
  },
  dosyaFormatHata: {
    id: "masterdata.common.dosyaFormatHata",
    defaultMessage:
      "Excel formatı yanlıştır. Lütfen istenilen excel formatını yükleyiniz.",
  },
  dosyaYukle: {
    id: "masterdata.common.dosyaYukle",
    defaultMessage: "Dosya Yükle",
  },
  sirketLogoEkleme: {
    id: "masterdata.common.sirketLogoEkleme",
    defaultMessage: "Şirket Logosu Ekle",
  },
  ticSicNo: {
    id: "masterdata.common.ticSicNo",
    defaultMessage: "Tic. Sic. No",
  },
  logoEkle: {
    id: "masterdata.common.logoEkle",
    defaultMessage: "Logo Ekle",
  },
  bulunamadi: {
    id: "masterdata.common.bulunamadi",
    defaultMessage: "Bulunamadı",
  },
  icerigeUlasilamadi: {
    id: "masterdata.common.icerigeUlasilamadi",
    defaultMessage: "Aradığınız içeriğe ulaşamadık.",
  },
  anasayfayaDon: {
    id: "masterdata.common.anasayfayaDon",
    defaultMessage: "Anasayfaya dön",
  },
  izinVerilmedi: {
    id: "masterdata.common.izinVerilmedi",
    defaultMessage: "İzin verilmedi",
  },
  sayfaYetkisiYok: {
    id: "masterdata.common.sayfaYetkisiYok",
    defaultMessage: "Bu sayfayı görüntülemek için yetkiniz yok.",
  },
  yukleniyor: {
    id: "masterdata.common.yukleniyor",
    defaultMessage: "Yükleniyor...",
  },
  onaydakiler: {
    id: "masterdata.common.onaydakiler",
    defaultMessage: "Onaydakiler",
  },
  onaylananlar: {
    id: "masterdata.common.onaylananlar",
    defaultMessage: "Onaylananlar",
  },
  reddedilenler: {
    id: "masterdata.common.reddedilenler",
    defaultMessage: "Reddedilenler",
  },
  bakiyeOnay: {
    id: "masterdata.common.bakiyeOnay",
    defaultMessage: "Bakiye onaylanmıştır.",
  },
  bakiyeRed: {
    id: "masterdata.common.bakiyeRed",
    defaultMessage: "Bakiye reddedilmiştir.",
  },
  borc: {
    id: "masterdata.common.borc",
    defaultMessage: "BORÇ",
  },
  alacak: {
    id: "masterdata.common.alacak",
    defaultMessage: "ALACAK",
  },
  tarih: {
    id: "masterdata.common.tarih",
    defaultMessage: "Tarih",
  },
  mutabakatYasa: {
    id: "masterdata.common.mutabakatYasa",
    defaultMessage:
      "Mutabakat veya itirazınızı 7 gün içinde bildirmediğiniz takdirde T.T.K’nun 94.maddesi gereğince bakiyede mutabık sayılacağımızı hatırlatırız.",
  },
  bakiyeOnaySoru: {
    id: "masterdata.common.bakiyeOnaySoru",
    defaultMessage: "Bakiyeyi onaylamak istediğinize emin misiniz?",
  },
  onayla: {
    id: "masterdata.common.onayla",
    defaultMessage: "Onayla",
  },
  reddet: {
    id: "masterdata.common.reddet",
    defaultMessage: "Reddet",
  },
  malHizmetBedeli: {
    id: "masterdata.common.malHizmetBedeli",
    defaultMessage: "MAL & HİZMET BEDELİ",
  },
  toplamBakiye: {
    id: "masterdata.common.toplamBakiye",
    defaultMessage: "TOPLAM BAKİYE",
  },
  mektupIndir: {
    id: "masterdata.common.mektupIndir",
    defaultMessage: "Mutabakat mektubunu indir",
  },
  topluMektupIndir: {
    id: "masterdata.common.topluMektupIndir",
    defaultMessage: "Mektuplar",
  },
  bakiyeOnayGeriAlindi: {
    id: "masterdata.common.bakiyeOnayGeriAlindi",
    defaultMessage: "Bakiye onayı geri alınmıştır.",
  },
  onaylandi: {
    id: "masterdata.common.onaylandi",
    defaultMessage: "ONAYLANDI",
  },
  bakiyeOnayGeriAlSoru: {
    id: "masterdata.common.bakiyeOnayGeriAlSoru",
    defaultMessage: "Bakiye onayını geri almak istediğinize emin misiniz?",
  },
  geriAl: {
    id: "masterdata.common.geriAl",
    defaultMessage: "Taslağa Geri Çek",
  },
  reddedildi: {
    id: "masterdata.common.reddedildi",
    defaultMessage: "REDDEDİLDİ",
  },
  bakiyeRetGeriAlSoru: {
    id: "masterdata.common.bakiyeRetGeriAlSoru",
    defaultMessage: "Bakiye reddini geri almak istediğinize emin misiniz?",
  },
  yanlisDosyaTipi: {
    id: "masterdata.common.yanlisDosyaTipi",
    defaultMessage: "Yanlış dosya tipi",
  },
  msExcelDosyaUyari: {
    id: "masterdata.common.msExcelDosyaUyari",
    defaultMessage: "Lütfen ms-excel tipinde bir dosya yükleyiniz.",
  },
  xlsxExcelDosyaUyari: {
    id: "masterdata.common.xlsxExcelDosyaUyari",
    defaultMessage: "Lütfen .xlsx uzantılı bir excel dosyası yükleyiniz.",
  },
  uyari: {
    id: "masterdata.common.uyari",
    defaultMessage: "Uyarı",
  },
  redAciklamaBosOlmamali: {
    id: "masterdata.common.redAciklamaBosOlmamali",
    defaultMessage: "Bakiye red açıklaması ve dosya alanı boş olmamalıdır.",
  },
  dosyaGirilmeli: {
    id: "masterdata.common.dosyaGirilmeli",
    defaultMessage: "Dosya eki yüklenmelidir.",
  },
  bakiyeReddedildi: {
    id: "masterdata.common.bakiyeReddedildi",
    defaultMessage: "Bakiye reddedilmiştir.",
  },
  retAciklamasi: {
    id: "masterdata.common.retAciklamasi",
    defaultMessage: "Ret Açıklaması",
  },
  dosyaEkiOpsiyonel: {
    id: "masterdata.common.dosyaEkiOpsiyonel",
    defaultMessage: "Dosya Eki (Opsiyonel)",
  },
  aciklamaGiriniz: {
    id: "masterdata.common.aciklamaGiriniz",
    defaultMessage: "Açıklama giriniz",
  },
  cariHesaplar: {
    id: "masterdata.common.cariHesaplar",
    defaultMessage: "Cari Hesaplar",
  },
  grupKoduMusteriKoduDoluOlmali: {
    id: "masterdata.common.grupKoduMusteriKoduDoluOlmali",
    defaultMessage:
      "Grup kodu ya da müşteri kodu alanlarından biri dolu olmalıdır.",
  },
  entegrasyonBasladi: {
    id: "masterdata.common.entegrasyonBasladi",
    defaultMessage: "Mutabakat entegrasyon işlemi başlamıştır.",
  },
  dosyaOkumaBasladi: {
    id: "masterdata.common.dosyaOkumaBasladi",
    defaultMessage: "Dosya okuma işlemi başlamıştır.",
  },
  islemTamamBilgi: {
    id: "masterdata.common.islemTamamBilgi",
    defaultMessage: "İşlem tamamlandığında bilgi verilecektir.",
  },
  dosyaOkumaTamamBilgi: {
    id: "masterdata.common.dosyaOkumaTamamBilgi",
    defaultMessage: "Tamamlandığında bilgi verilecektir.",
  },
  musteri: {
    id: "masterdata.common.musteri",
    defaultMessage: "Müşteri",
  },
  satici: {
    id: "masterdata.common.satici",
    defaultMessage: "Satıcı",
  },
  bildirimAlis: {
    id: "masterdata.common.bildirimAlis",
    defaultMessage: "Bildirim Alış (BA)",
  },
  bildirimSatis: {
    id: "masterdata.common.bildirimSatis",
    defaultMessage: "Bildirim Satış (BS)",
  },
  mutabakatExcel: {
    id: "masterdata.common.mutabakatExcel",
    defaultMessage: "Mutabakat Excel Yükleme",
  },
  karsiMutabakat: {
    id: "masterdata.common.karsiMutabakat",
    defaultMessage: "Karşı Mutabakat",
  },
  saticiBakiyeleri: {
    id: "masterdata.common.saticiBakiyeleri",
    defaultMessage: "Satıcı Bakiyeleri",
  },
  musteriBakiyeleri: {
    id: "masterdata.common.musteriBakiyeleri",
    defaultMessage: "Müşteri Bakiyeleri",
  },
  sapMutabakatBaslat: {
    id: "masterdata.common.sapMutabakatBaslat",
    defaultMessage: "SAP {header} Mutabakatı Başlat",
  },
  donemYil: {
    id: "masterdata.common.donemYil",
    defaultMessage: "Dönem/Yıl",
  },
  donemYilZorunlu: {
    id: "masterdata.common.donemYilZorunlu",
    defaultMessage: "Dönem/yıl zorunludur",
  },
  donemYilSeciniz: {
    id: "masterdata.common.donemYilSeciniz",
    defaultMessage: "Dönem/yıl seçiniz.",
  },
  asgariSatisHacmi: {
    id: "masterdata.common.asgariSatisHacmi",
    defaultMessage: "Asgari Satış Hacmi",
  },
  asgariSatisHacmiZorunlu: {
    id: "masterdata.common.asgariSatisHacmiZorunlu",
    defaultMessage: "Asgari satış hacmi zorunludur",
  },
  acikKalemAnahtarTarihi: {
    id: "masterdata.common.acikKalemAnahtarTarihi",
    defaultMessage: "Açık Kalem Anahtar Tarihi",
  },
  acikKalemAnahtarTarihiZorunlu: {
    id: "masterdata.common.acikKalemAnahtarTarihiZorunlu",
    defaultMessage: "Açık kalem anahtar tarihi zorunludur",
  },
  tarihSeciniz: {
    id: "masterdata.common.tarihSeciniz",
    defaultMessage: "Tarih seçiniz.",
  },
  saticiKodlari: {
    id: "masterdata.common.saticiKodlari",
    defaultMessage: "Satıcı Kodları",
  },
  musteriKodlari: {
    id: "masterdata.common.musteriKodlari",
    defaultMessage: "Müşteri Kodları",
  },
  cokluKodUyari: {
    id: "masterdata.common.cokluKodUyari",
    defaultMessage:
      "Birden fazla kod varsa alt alta yazabilir ya da excelden kopyalayıp yapıştırabilirsiniz. Toplu aktarımlar için bu alanı boş geçiniz.",
  },
  alacakLimitAralik: {
    id: "masterdata.common.alacakLimitAralik",
    defaultMessage: "Alacak Limit Aralığı",
  },
  borcLimitAralik: {
    id: "masterdata.common.borcLimitAralik",
    defaultMessage: "Borç Limit Aralığı",
  },
  dahil: {
    id: "masterdata.common.dahil",
    defaultMessage: "Dahil",
  },
  haric: {
    id: "masterdata.common.haric",
    defaultMessage: "Hariç",
  },
  standartKalemler: {
    id: "masterdata.common.standartKalemler",
    defaultMessage: "Standart Kalemler",
  },
  odkIslemleri: {
    id: "masterdata.common.odkIslemleri",
    defaultMessage: "ÖDK İşlemleri",
  },
  mutabakatBaslat: {
    id: "masterdata.common.mutabakatBaslat",
    defaultMessage: "Mutabakat Başlat",
  },
  cariHesapOzeti: {
    id: "masterdata.common.cariHesapOzeti",
    defaultMessage: "CARİ HESAP ÖZETİ",
  },
  babsOzeti: {
    id: "masterdata.common.babsOzeti",
    defaultMessage: "BA/BS ÖZETİ",
  },
  belgeTutar: {
    id: "masterdata.common.belgeTutar",
    defaultMessage: "Belge Tutarı",
  },
  paraBirimi: {
    id: "masterdata.common.paraBirimi",
    defaultMessage: "Para Birimi",
  },
  acikKalemler: {
    id: "masterdata.common.acikKalemler",
    defaultMessage: "Açık Kalemler",
  },
  ekstreler: {
    id: "masterdata.common.ekstreler",
    defaultMessage: "Ekstreler",
  },
  belgeTarihi: {
    id: "masterdata.common.belgeTarihi",
    defaultMessage: "Belge Tarihi",
  },
  tayin: {
    id: "masterdata.common.tayin",
    defaultMessage: "Tayin",
  },
  tur: {
    id: "masterdata.common.tur",
    defaultMessage: "Tür",
  },
  belgeNo: {
    id: "masterdata.common.belgeNo",
    defaultMessage: "Belge No",
  },
  tutar: {
    id: "masterdata.common.tutar",
    defaultMessage: "Tutar",
  },
  pb: {
    id: "masterdata.common.pb",
    defaultMessage: "PB",
  },
  metin: {
    id: "masterdata.common.metin",
    defaultMessage: "Metin",
  },
  kullanici: {
    id: "masterdata.common.kullanici",
    defaultMessage: "Kullanıcı",
  },
  belgeAdedi: {
    id: "masterdata.common.belgeAdedi",
    defaultMessage: "Belge Adedi",
  },
  malveHizmetBedeli: {
    id: "masterdata.common.malveHizmetBedeli",
    defaultMessage: "Mal ve Hizmet Bedeli",
  },
  matrah: {
    id: "masterdata.common.matrah",
    defaultMessage: "Matrah",
  },
  vergi: {
    id: "masterdata.common.vergi",
    defaultMessage: "Vergi",
  },
  yil: {
    id: "masterdata.common.yil",
    defaultMessage: "Yıl",
  },
  kalem: {
    id: "masterdata.common.kalem",
    defaultMessage: "Kalem",
  },
  bilgi: {
    id: "masterdata.common.bilgi",
    defaultMessage: "Bilgi",
  },
  kalemAktarimBilgi: {
    id: "masterdata.common.kalemAktarimBilgi",
    defaultMessage:
      "Kalemler aktarılmaya başlamıştır. Birkaç dakika içinde ilgili bakiye detayından kontrol edebilirsiniz.",
  },
  acikKalemAktarimOnay: {
    id: "masterdata.common.acikKalemAktarimOnay",
    defaultMessage: "Bakiyeye ait açık kalemleri aktrmak istiyor musunuz?",
  },
  kalemleriAktar: {
    id: "masterdata.common.kalemleriAktar",
    defaultMessage: "Kalemleri aktar",
  },
  ekstreTalepBekleme: {
    id: "masterdata.common.ekstreTalepBekleme",
    defaultMessage:
      "{tarih} başlangıç tarihi için yaptığınız ekstre talep onayınız beklemektedir.",
  },
  ekstreTalepOnay: {
    id: "masterdata.common.ekstreTalepOnay",
    defaultMessage:
      "{tarih} başlangıç tarihi için yaptığınız talebiniz onaylanmıştır, ekstreler detayından görüntüleyebilirsiniz.",
  },
  ekstreTalepEt: {
    id: "masterdata.common.ekstreTalepEt",
    defaultMessage: "Ekstre Talep Et",
  },
  dosyaEki: {
    id: "masterdata.common.dosyaEki",
    defaultMessage: "Dosya Eki",
  },
  indir: {
    id: "masterdata.common.indir",
    defaultMessage: "İndir",
  },
  retBilgisiYok: {
    id: "masterdata.common.retBilgisiYok",
    defaultMessage: "Bakiyeye ait ret bilgisi bulunmamaktadır.",
  },
  ekstreBilgisi: {
    id: "masterdata.common.ekstreBilgisi",
    defaultMessage: "EKSTRE BİLGİSİ",
  },
  geriDon: {
    id: "masterdata.common.geriDon",
    defaultMessage: "Geri Dön",
  },
  excelAl: {
    id: "masterdata.common.excelAl",
    defaultMessage: "Excel Al",
  },
  tarihAraligi: {
    id: "masterdata.common.tarihAraligi",
    defaultMessage: "Tarih Aralığı",
  },
  baslangic: {
    id: "masterdata.common.baslangic",
    defaultMessage: "Başlangıç",
  },
  bitis: {
    id: "masterdata.common.bitis",
    defaultMessage: "Bitiş",
  },
  belgeTuru: {
    id: "masterdata.common.belgeTuru",
    defaultMessage: "Belge Türü",
  },
  belgeTuruSeciniz: {
    id: "masterdata.common.belgeTuruSeciniz",
    defaultMessage: "Belge Türü Seçiniz",
  },
  ekstrelerAktarilmadi: {
    id: "masterdata.common.ekstrelerAktarilmadi",
    defaultMessage:
      "Bakiyeye ait ekstreler henüz aktarılmamıştır. You can make extract request from the current account summary page.",
  },
  faturaNo: {
    id: "masterdata.common.faturaNo",
    defaultMessage: "Fatura No",
  },
  acikKalemBilgisi: {
    id: "masterdata.common.acikKalemBilgisi",
    defaultMessage: "AÇIK KALEM BİLGİSİ",
  },
  babsDokumu: {
    id: "masterdata.common.babsDokumu",
    defaultMessage: "BA/BS DÖKÜMÜ",
  },
  kalemleriAktarmadiniz: {
    id: "masterdata.common.kalemleriAktarmadiniz",
    defaultMessage: "Bakiyeye ait kalemleri henüz aktarmadınız.",
  },
  ekstreTalebiAlindi: {
    id: "masterdata.common.ekstreTalebiAlindi",
    defaultMessage: "Ekstre talebiniz alınmıştır.",
  },
  baslangicTarihi: {
    id: "masterdata.common.baslangicTarihi",
    defaultMessage: "Başlangıç Tarihi",
  },
  bakiyeler: {
    id: "masterdata.common.bakiyeler",
    defaultMessage: "Bakiyeler",
  },
  retBilgisi: {
    id: "masterdata.common.retBilgisi",
    defaultMessage: "Ret Bilgisi",
  },
  devir: {
    id: "masterdata.common.devir",
    defaultMessage: "Bakiye",
  },
  toplamDevirliBakiye: {
    id: "masterdata.common.toplamDevirliBakiye",
    defaultMessage: "Toplam Devirli Bakiye",
  },
  mektupDiliniSeciniz: {
    id: "masterdata.common.mektupDiliniSeciniz",
    defaultMessage: "Mektup dilini seçiniz.",
  },
  turkce: {
    id: "masterdata.common.turkce",
    defaultMessage: "Türkçe",
  },
  ingilizce: {
    id: "masterdata.common.ingilizce",
    defaultMessage: "İngilizce",
  },
  musteriSeciniz: {
    id: "masterdata.common.musteriSeciniz",
    defaultMessage: "Müşteri Seçiniz",
  },
  taslak: {
    id: "masterdata.common.taslak",
    defaultMessage: "Taslak",
  },
  onayda: {
    id: "masterdata.common.onayda",
    defaultMessage: "Onayda",
  },
  ret: {
    id: "masterdata.common.ret",
    defaultMessage: "Ret",
  },
  adresDegisikligi: {
    id: "masterdata.common.adresDegisikligi",
    defaultMessage: "Adres Değişikliği",
  },
  rOnayda: {
    id: "masterdata.common.rOnayda",
    defaultMessage: "ROnayda",
  },
  rOnay: {
    id: "masterdata.common.rOnay",
    defaultMessage: "ROnay",
  },
  kOnay: {
    id: "masterdata.common.kOnay",
    defaultMessage: "ROnay",
  },
  onay: {
    id: "masterdata.common.onay",
    defaultMessage: "Onay",
  },

  musteriKoduGiriniz: {
    id: "masterdata.common.musteriKoduGiriniz",
    defaultMessage: "Müşteri Kodu Giriniz",
  },
  belgeler: {
    id: "masterdata.common.belgeler",
    defaultMessage: "Belgeler",
  },
  aktarilmis: {
    id: "masterdata.common.aktarilmis",
    defaultMessage: "Aktarılmış",
  },
  aktarilmamis: {
    id: "masterdata.common.aktarilmamis",
    defaultMessage: "Aktarılmamış",
  },
  musteriMail: {
    id: "masterdata.common.musteriMail",
    defaultMessage: "Müşteri Mail",
  },
  gonderilmis: {
    id: "masterdata.common.gonderilmis",
    defaultMessage: "Gönderilmiş",
  },
  gonderilmemis: {
    id: "masterdata.common.gonderilmemis",
    defaultMessage: "Gönderilmemiş",
  },
  onayMaili: {
    id: "masterdata.common.onayMaili",
    defaultMessage: "Onay Maili",
  },
  musteriVkn: {
    id: "masterdata.common.musteriVkn",
    defaultMessage: "Müşteri Vkn",
  },
  vknGiriniz: {
    id: "masterdata.common.vknGiriniz",
    defaultMessage: "Vkn Giriniz",
  },
  benimOlusturduklarim: {
    id: "masterdata.common.benimOlusturduklarim",
    defaultMessage: "Benim Oluşturduklarım",
  },
  kullaniciSeciniz: {
    id: "masterdata.common.kullaniciSeciniz",
    defaultMessage: "Kullanıcı Seçiniz",
  },
  vkn: {
    id: "masterdata.common.vkn",
    defaultMessage: "Vkn",
  },
  kod: {
    id: "masterdata.common.kod",
    defaultMessage: "Kod",
  },
  onayGonderilenMail: {
    id: "masterdata.common.onayGonderilenMail",
    defaultMessage: "Onay Adresi",
  },
  adet: {
    id: "masterdata.common.adet",
    defaultMessage: "Adet",
  },
  gonderim: {
    id: "masterdata.common.gonderim",
    defaultMessage: "Gönderim",
  },
  belgelerAktarildi: {
    id: "masterdata.common.belgelerAktarildi",
    defaultMessage:
      "Belgelerin aktarımı yapılmıştır, BA/BS detayından kontrol edebilirsiniz.",
  },
  belgeAktarimiBaslat: {
    id: "masterdata.common.belgeAktarimiBaslat",
    defaultMessage:
      "BA/BS kaydına ait belgelerin aktarımını başlatmak istiyor musunuz?",
  },
  belgeleriAktar: {
    id: "masterdata.common.belgeleriAktar",
    defaultMessage: "Belgeleri aktar",
  },
  musteriOnayindaBeklemekte: {
    id: "masterdata.common.musteriOnayindaBeklemekte",
    defaultMessage: "Müşteri onayında beklemektedir",
  },
  mutabakatMusteriOnayi: {
    id: "masterdata.common.mutabakatMusteriOnayi",
    defaultMessage:
      "Mutabakatı müşteri onayına göndermek istediğinize emin misiniz?",
  },
  onayaGonder: {
    id: "masterdata.common.onayaGonder",
    defaultMessage: "Müşteri onayına gönder",
  },
  onayaGonderildi: {
    id: "masterdata.common.onayaGonderildi",
    defaultMessage: "Mutabakat müşteri onayına gönderilmiştir.",
  },
  belgeAktarimiBasladi: {
    id: "masterdata.common.belgeAktarimiBasladi",
    defaultMessage:
      "Belgeler aktarılmaya başlamıştır. Birkaç dakika içinde ilgili BA/BS detayından kontrol edebilirsiniz.",
  },
  bitisTarihi: {
    id: "masterdata.common.bitisTarihi",
    defaultMessage: "Bitiş Tarihi",
  },
  kapsamTipi: {
    id: "masterdata.common.kapsamTipi",
    defaultMessage: "Kapsam Tipi",
  },
  toplu: {
    id: "masterdata.common.toplu",
    defaultMessage: "Toplu",
  },
  musteriBazli: {
    id: "masterdata.common.musteriBazli",
    defaultMessage: "Müşteri Bazlı",
  },
  donem: {
    id: "masterdata.common.donem",
    defaultMessage: "Dönem",
  },
  donemGiriniz: {
    id: "masterdata.common.donemGiriniz",
    defaultMessage: "Dönem Giriniz",
  },
  mutabakatTipi: {
    id: "masterdata.common.mutabakatTipi",
    defaultMessage: "Mutabakat Tip",
  },
  bakiyelerMusteriOnayinaGonderildi: {
    id: "masterdata.common.bakiyelerMusteriOnayinaGonderildi",
    defaultMessage:
      "Bakiyeler müşterilerin onayına mail olarak gönderilmeye başlanmıştır.",
  },
  onayGondermeKapsamSeciniz: {
    id: "masterdata.common.onayGondermeKapsamSeciniz",
    defaultMessage: "Müşteri onayına gönderme kapsamını seçiniz.",
  },
  tumunuGonder: {
    id: "masterdata.common.tumunuGonder",
    defaultMessage: "Tümünü Gönder",
  },
  kendiMutabakatlarimiGonder: {
    id: "masterdata.common.kendiMutabakatlarimiGonder",
    defaultMessage: "Kendi Mutabakatlarımı Gönder",
  },
  bakiyelerTopluMusteriOnayinaGonderildi: {
    id: "masterdata.common.bakiyelerTopluMusteriOnayinaGonderildi",
    defaultMessage:
      "Mutabakat bakiyeleri toplu olarak müşterilerin onayına gönderilmiştir.",
  },
  tip: {
    id: "masterdata.common.tip",
    defaultMessage: "Tip",
  },
  kapsam: {
    id: "masterdata.common.kapsam",
    defaultMessage: "Kapsam",
  },
  kabul: {
    id: "masterdata.common.kabul",
    defaultMessage: "Kabul",
  },
  referans: {
    id: "masterdata.common.referans",
    defaultMessage: "Referans",
  },
  retAciklamasiYok: {
    id: "masterdata.common.retAciklamasiYok",
    defaultMessage: "Bakiyeye ait ret açıklaması bulunmamaktadır.",
  },
  babsBelgeleriAktarilmamis: {
    id: "masterdata.common.babsBelgeleriAktarilmamis",
    defaultMessage:
      "BA/BS kaydına ait belgeler henüz aktarılmamıştır. Müşteri listesi üzerinden belgeleri aktarabilirsiniz.",
  },
  babsDetayi: {
    id: "masterdata.common.babsDetayi",
    defaultMessage: "MÜŞTERİ BA/BS MUTABAKAT DETAYI",
  },
  degisikliklerBasarili: {
    id: "masterdata.common.degisikliklerBasarili",
    defaultMessage: "Değişiklikler başarıyla gerçekleştirildi.",
  },
  tutarFormatiYanlis: {
    id: "masterdata.common.tutarFormatiYanlis",
    defaultMessage: "Tutar formatı yanlış (örnek kullanım: 123.45)",
  },
  belgeAdediZorunludur: {
    id: "masterdata.common.belgeAdediZorunludur",
    defaultMessage: "Belge adedi zorunludur",
  },
  belgeAdediGiriniz: {
    id: "masterdata.common.belgeAdediGiriniz",
    defaultMessage: "Belge adedi giriniz",
  },
  malHizmetBedeliZorunludur: {
    id: "masterdata.common.malHizmetBedeliZorunludur",
    defaultMessage: "Mal & hizmet bedeli zorunludur",
  },
  malHizmetBedeliGiriniz: {
    id: "masterdata.common.malHizmetBedeliGiriniz",
    defaultMessage: "Mal & hizmet bedeli giriniz",
  },
  ozet: {
    id: "masterdata.common.ozet",
    defaultMessage: "ÖZET",
  },
  mutabakatTakip: {
    id: "masterdata.common.mutabakatTakip",
    defaultMessage: "Mutabakat Takip",
  },
  musteriSatici: {
    id: "masterdata.common.musteriSatici",
    defaultMessage: "Müşteri/Satıcı",
  },
  kaydedildi: {
    id: "masterdata.common.kaydedildi",
    defaultMessage: "Kaydedildi",
  },
  kaydedilmedi: {
    id: "masterdata.common.kaydedilmedi",
    defaultMessage: "Kaydedilmedi",
  },
  acikKalemlerAktarilmamis: {
    id: "masterdata.common.acikKalemlerAktarilmamis",
    defaultMessage:
      "Bakiyeye ait açık kalemler henüz aktarılmamıştır. Müşteri listesi üzerinden açık kalemleri aktarabilirsiniz.",
  },
  musteriMutabakatDetayi: {
    id: "masterdata.common.musteriMutabakatDetayi",
    defaultMessage: "MÜŞTERİ MUTABAKAT DETAYI",
  },
  musteriEkstreDetayi: {
    id: "masterdata.common.musteriEkstreDetayi",
    defaultMessage: "MÜŞTERİ EKSTRE DETAYI",
  },
  bakiyeDuzenle: {
    id: "masterdata.common.bakiyeDuzenle",
    defaultMessage: "BAKİYE DÜZENLE",
  },
  belgeTutariZorunludur: {
    id: "masterdata.common.belgeTutariZorunludur",
    defaultMessage: "Belge tutarı zorunludur",
  },
  belgeTutariGiriniz: {
    id: "masterdata.common.belgeTutariGiriniz",
    defaultMessage: "Belge tutarı giriniz",
  },
  upbZorunlu: {
    id: "masterdata.common.upbZorunlu",
    defaultMessage: "UPB karşılığı zorunludur",
  },
  upbGiriniz: {
    id: "masterdata.common.upbGiriniz",
    defaultMessage: "UPB tutarı giriniz",
  },
  upb2Zorunlu: {
    id: "masterdata.common.upb2Zorunlu",
    defaultMessage: "UPB2 karşılığı zorunludur",
  },
  upb2Giriniz: {
    id: "masterdata.common.upb2Giriniz",
    defaultMessage: "UPB2 tutarı giriniz",
  },
  upb3Zorunlu: {
    id: "masterdata.common.upb3Zorunlu",
    defaultMessage: "UPB3 karşılığı zorunludur",
  },
  upb3Giriniz: {
    id: "masterdata.common.upb3Giriniz",
    defaultMessage: "UPB3 tutarı giriniz",
  },
  bakiyeManuelGuncellendi: {
    id: "masterdata.common.bakiyeManuelGuncellendi",
    defaultMessage: "Bakiyeler manuel güncellendi.",
  },
  bakiyeOrjinalDegerinde: {
    id: "masterdata.common.bakiyeOrjinalDegerinde",
    defaultMessage: "Bakiyeler orijinal değerindedir.",
  },
  ekstreTalep: {
    id: "masterdata.common.ekstreTalep",
    defaultMessage: "Ekstre Talep",
  },
  acikKalemlerinAktarimiYapildi: {
    id: "masterdata.common.acikKalemlerinAktarimiYapildi",
    defaultMessage:
      "Açık kalemlerin aktarımı yapılmıştır, ilgili bakiye detayından kontrol edebilirsiniz.",
  },
  acikKalemlerAktarilamaz: {
    id: "masterdata.common.acikKalemlerAktarilamaz",
    defaultMessage:
      "Bakiye tutarlarında manuel güncelleme yapılmıştır, açık kalemler aktarılamaz.",
  },
  acikKalemlerAktarilsinMi: {
    id: "masterdata.common.acikKalemlerAktarilsinMi",
    defaultMessage:
      "Bakiyeye ait açık kalemlerin aktarımı yapmak istiyor musunuz?",
  },
  bakiyelerGuncellensinMi: {
    id: "masterdata.common.bakiyelerGuncellensinMi",
    defaultMessage: "Bakiyeler SAP tarafından güncellensin mi ?",
  },
  acikKalemleriAktar: {
    id: "masterdata.common.acikKalemleriAktar",
    defaultMessage: "Açık kalemleri aktar",
  },
  ekstreTalepOnayiVar: {
    id: "masterdata.common.ekstreTalepOnayiVar",
    defaultMessage: "Ekstre talep onayı bulunmamaktadır.",
  },
  ekstreTalepOnayiVerildi: {
    id: "masterdata.common.ekstreTalepOnayiVerildi",
    defaultMessage: "Ekstre talep onayı verilmiştir.",
  },
  ekstreTalebiniOnayliyormusunuz: {
    id: "masterdata.common.ekstreTalebiniOnayliyormusunuz",
    defaultMessage: "Ekstre talebini onaylıyor musunuz?",
  },
  ekstreTalebiniOnayla: {
    id: "masterdata.common.ekstreTalebiniOnayla",
    defaultMessage: "Ekstre talebi onayla",
  },
  ekstreTalebiOnaylandi: {
    id: "masterdata.common.ekstreTalebiOnaylandi",
    defaultMessage: "Ekstre talebi onaylanmıştır.",
  },
  ekstreTalebiReddedildi: {
    id: "masterdata.common.ekstreTalebiReddedildi",
    defaultMessage: "Ekstre talebi reddedildi.",
  },
  acikKalemlerAktariliyor: {
    id: "masterdata.common.acikKalemlerAktariliyor",
    defaultMessage:
      "Açık kalemler aktarılmaya başlamıştır. Birkaç dakika içinde ilgili bakiye detayından kontrol edebilirsiniz.",
  },
  bakiyeGuncelleniyor: {
    id: "masterdata.common.bakiyeGuncelleniyor",
    defaultMessage:
      "Bakiyeler güncellenmeye başlamıştır. Birkaç dakika içinde tekrar kontrol edebilirsiniz.",
  },
  musteriEMail: {
    id: "masterdata.common.musteriEMail",
    defaultMessage: "Müşteri E-Mail",
  },
  filtre: {
    id: "masterdata.common.filtre",
    defaultMessage: "Filtre",
  },
  manuelIslem: {
    id: "masterdata.common.manuelIslem",
    defaultMessage: "Manuel İşlem",
  },
  yapilmis: {
    id: "masterdata.common.yapilmis",
    defaultMessage: "Yapılmış",
  },
  yapilmamis: {
    id: "masterdata.common.yapilmamis",
    defaultMessage: "Yapılmamış",
  },
  mutabakatBaslatma: {
    id: "masterdata.common.mutabakatBaslatma",
    defaultMessage: "Mutabakat Başlat",
  },
  anaVeri: {
    id: "masterdata.common.anaVeri",
    defaultMessage: "Ana Veri",
  },
  tarihBaslik: {
    id: "masterdata.common.tarihBaslik",
    defaultMessage: "TARİH",
  },
  donemBaslik: {
    id: "masterdata.common.donemBaslik",
    defaultMessage: "DÖNEM",
  },
  alacakMin: {
    id: "masterdata.common.alacakMin",
    defaultMessage: "Alacak",
  },
  borcMin: {
    id: "masterdata.common.borcMin",
    defaultMessage: "Borç",
  },
  oge: {
    id: "masterdata.common.oge",
    defaultMessage: "öğe",
  },
  yenile: {
    id: "masterdata.common.yenile",
    defaultMessage: "Yenile",
  },
  ekstreOnayi: {
    id: "masterdata.common.ekstreOnayi",
    defaultMessage: "Ekstre Onayı",
  },
  bekleyen: {
    id: "masterdata.common.bekleyen",
    defaultMessage: "Bekleyen",
  },
  beklemeyen: {
    id: "masterdata.common.beklemeyen",
    defaultMessage: "Beklemeyen",
  },
  muhasebeciEkstrelerAktarilmadi: {
    id: "masterdata.common.muhasebeciEkstrelerAktarilmadi",
    defaultMessage:
      "Ekstreler henüz aktarılmamıştır. Müşterinin ekstre talebi yapması ya da bekleyen bir ekstre talebi varsa onay vermeniz gerekmektedir.",
  },
  musteriyeGonder: {
    id: "masterdata.common.musteriyeGonder",
    defaultMessage: "Gönder",
  },
  musteriyeGonderme: {
    id: "masterdata.common.musteriyeGonderme",
    defaultMessage: "Gönderme",
  },
  musteriOnayi: {
    id: "masterdata.common.musteriOnayi",
    defaultMessage: "Müşteri Onayına",
  },
  onayaGonderimStatusuDegisti: {
    id: "masterdata.common.onayaGonderimStatusuDegisti",
    defaultMessage: "Onaya gönderim statüsü başarıyla değiştirildi.",
  },
  gonderildi: {
    id: "masterdata.common.gonderildi",
    defaultMessage: "Gönderildi",
  },
  gonderilmedi: {
    id: "masterdata.common.gonderilmedi",
    defaultMessage: "Gönderilmedi",
  },
  belgeadet: {
    id: "masterdata.common.belgeadet",
    defaultMessage: "ADET",
  },
  kayitTarihi: {
    id: "masterdata.common.kayitTarihi",
    defaultMessage: "Kayıt Tarihi",
  },
  acikKlmAnhTrh: {
    id: "masterdata.common.acikKlmAnhTrh",
    defaultMessage: "A.K.T.",
  },
  arsivdenGeriAl: {
    id: "masterdata.common.arsivdenGeriAl",
    defaultMessage: "Mutabakatı Arşivden Geri Al",
  },
  arsivdenGeriAlmayaEminMisiniz: {
    id: "masterdata.common.arsivdenGeriAlmayaEminMisiniz",
    defaultMessage: "Mutabakatı arşivden geri almak istediğinize emin misiniz?",
  },
  arsivle: {
    id: "masterdata.common.arsivle",
    defaultMessage: "Mutabakatı Arşivle",
  },
  arsivlemeyeEminMisiniz: {
    id: "masterdata.common.arsivlemeyeEminMisiniz",
    defaultMessage: "Mutabakatı arşivlemek istediğinize emin misiniz?",
  },
  arsivlendi: {
    id: "masterdata.common.arsivlendi",
    defaultMessage: "Mutabakat arşivlendi.",
  },
  arsivdenGeriAlindi: {
    id: "masterdata.common.arsivdenGeriAlindi",
    defaultMessage: "Mutabakat arşivden geri alındı.",
  },
  arsivlendiMi: {
    id: "masterdata.common.arsivlendiMi",
    defaultMessage: "Arşivlendi Mi",
  },
  mailiVarMi: {
    id: "masterdata.common.mailiVarMi",
    defaultMessage: "Maili Var Mı",
  },
  onaydanGeriAlmayaEminMisiniz: {
    id: "masterdata.common.onaydanGeriAlmayaEminMisiniz",
    defaultMessage: "Kaydı onaydan geri çekmek istediğinize emin misiniz?",
  },
  onayGeriCekildi: {
    id: "masterdata.common.onayGeriCekildi",
    defaultMessage: "Bakiye onayı geri çekildi.",
  },
  toplamAdet: {
    id: "masterdata.common.toplamAdet",
    defaultMessage: "Toplam Adet",
  },
  belgeTuruAralik: {
    id: "masterdata.common.belgeTuruAralik",
    defaultMessage: "Belge Türleri",
  },
  cokluOnayGondermeOnayi: {
    id: "masterdata.common.cokluOnayGondermeOnayi",
    defaultMessage:
      "Seçilen kayıtlar onaya gönderilecektir. Onaylıyor musunuz?",
  },
  yazdirildiMi: {
    id: "masterdata.common.yazdirildiMi",
    defaultMessage: "Yazdırıldı Mı",
  },
  yazdir: {
    id: "masterdata.common.yazdir",
    defaultMessage: "Yazdır",
  },
  yazdirHtml: {
    id: "masterdata.common.yazdirHtml",
    defaultMessage: "HTML Yazdır",
  },
  emailDuzenle: {
    id: "masterdata.common.emailDuzenle",
    defaultMessage: "Email Düzenle",
  },
  isAlani: {
    id: "masterdata.common.isAlani",
    defaultMessage: "İş Alanı",
  },
  isAlaniUyari: {
    id: "masterdata.common.isAlaniUyari",
    defaultMessage:
      "Birden fazla iş alanı varsa alt alta yazabilir ya da excelden kopyalayıp yapıştırabilirsiniz.",
  },
  notlar: {
    id: "masterdata.common.notlar",
    defaultMessage: "Notlar",
  },
  notKaydetBilgi: {
    id: "masterdata.common.notKaydetBilgi",
    defaultMessage: "Eklediğiniz not kaydedilmiştir.",
  },
  notGirisi: {
    id: "masterdata.common.notGirisi",
    defaultMessage: "Not Girişi",
  },
  ekDosya: {
    id: "masterdata.common.ekDosya",
    defaultMessage: "Ek Dosya",
  },
  bakiyeGuncelleSap: {
    id: "masterdata.common.bakiyeGuncelleSap",
    defaultMessage: "Bakiye Güncelle",
  },
  noktalivirgulUyari: {
    id: "masterdata.common.noktalivirgulUyari",
    defaultMessage:
      "BİRDEN FAZLA MAİL ADRESİ GİRİLECEKSE ARALARINA NOKTALI VİRGÜL (;) EKLENMESİ GEREKMEKTEDİR!",
  },
  extreDetay: {
    id: "masterdata.common.extreDetay",
    defaultMessage: "Ekstre Detay",
  },
  sapSatici: {
    id: "masterdata.common.sapSatici",
    defaultMessage: "Sap/Satıcı",
  },
  belgeParaBirimi: {
    id: "masterdata.common.belgeParaBirimi",
    defaultMessage: "Belge Para Birimi",
  },
  tlTutar: {
    id: "masterdata.common.tlTutar",
    defaultMessage: "TL Tutar",
  },
  eslestiMi: {
    id: "masterdata.common.eslestiMi",
    defaultMessage: "Eşleşti Mi",
  },
  ekstreKarsilastima: {
    id: "masterdata.common.ekstreKarsilatima",
    defaultMessage: "Ekstre Karşılaştırma",
  },
  sapSaticiFark: {
    id: "masterdata.common.sapSaticiFark",
    defaultMessage: "SAP/Satıcı Fark",
  },
  yenidenOnay: {
    id: "masterdata.common.yenidenOnay",
    defaultMessage: "Tekrar Onaya Gönder",
  },
  yenidenOnayBakiye: {
    id: "masterdata.common.yenidenOnayBakiye",
    defaultMessage: "Bakiyeler yeniden çekilip onaya gönderilsin mi?",
  },
  yenidenOnayaGonder: {
    id: "masterdata.common.yenidenOnayaGonder",
    defaultMessage: "Tekrar müşteri onayına gönder",
  },
  dosyaIndirme: {
    id: "masterdata.common.dosyaIndirme",
    defaultMessage: "Dosya alanına yüklenecek excel formatını indirmek için",
  },
  tıklayınız: {
    id: "masterdata.common.tıklayınız",
    defaultMessage: " tıklayınız.",
  },
});

export default commonResources;
